import { Trophy, Globe } from "lucide-react";
import { Badge } from "@/app/_module/components/ui/badge";

interface LeaderboardHeaderProps {
  agencyName?: string;
  isAgencyWide?: boolean;
  agencyWideNames?: string[];
}

export const LeaderboardHeader = function({ agencyName, isAgencyWide, agencyWideNames }: LeaderboardHeaderProps) {
  const title = isAgencyWide
    ? "Agency-Wide Leaderboard"
    : agencyName ? `${agencyName} Agents Leaderboard` : "Agents Leaderboard";

  const subtitle = isAgencyWide
    ? "Track and compare agent performance across all opted-in agencies"
    : agencyName
      ? `Track and compare agent performance in ${agencyName}`
      : "Track and compare independent agent performance across the USA";

  return (
    <div className="flex items-center justify-between" data-tour="leaderboard-header">
      <div className="flex items-center gap-3">
        <div className={`p-2 rounded-lg ${isAgencyWide ? 'bg-blue-100' : 'bg-yellow-100'}`}>
          {isAgencyWide ? <Globe className="h-6 w-6 text-blue-600" /> : <Trophy className="h-6 w-6 text-yellow-600" />}
        </div>
        <div>
          <h1 className="text-2xl font-semibold text-gray-900">{title}</h1>
          <p className="text-gray-600 mt-1">{subtitle}</p>
          {isAgencyWide && agencyWideNames && agencyWideNames.length > 0 && (
            <div className="flex items-center gap-1.5 mt-2 flex-wrap">
              {agencyWideNames.map(name => (
                <Badge key={name} variant="outline" className="text-[10px] font-medium bg-gray-50 text-gray-600 border-gray-200">
                  {name}
                </Badge>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
